/**
 * Reusable Check component
 *
 */
import React from 'react';
import { WhiteCheck } from '../assets/icons/WhiteCheck';
import { Checked, UnChecked } from './Check.styled';
var noop = function (e) {
    e.preventDefault();
};
function Check(_a) {
    var _b = _a.size, size = _b === void 0 ? '20px' : _b, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.colorVariant, colorVariant = _e === void 0 ? 'brand' : _e, _f = _a.onClick, onClick = _f === void 0 ? noop : _f;
    // Parse values into user-friendly strings
    return checked ? (React.createElement(Checked, { size: size, disabled: disabled, onClick: disabled ? noop : onClick, colorVariant: colorVariant },
        React.createElement(WhiteCheck, { width: "50%", height: "45%" }))) : (React.createElement(UnChecked, { size: size, disabled: disabled, onClick: disabled ? noop : onClick }));
}
export default Check;
